import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 2px;
  margin-left: 1px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  overflow: hidden;
`;
